import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAlert } from 'react-alert';

import { Card, MainSection } from "../common_components/Layout";
import { TitleAndText } from "./components/TitleAndText";
import { UserPoolButton, YourCommunityButton, LiveFeedbackButton, SurveyButton } from "./components/SquareButtons";
import BackButton from "./components/BackButton";
import Modal from "../common_components/Modal";
import { PrimaryButton, TertiaryLink } from "../common_components/Buttons";
import { PurpleYourCommunityModal, PurpleOtherFormatsModal } from "../common_components/PurpleModals";


// Api Calls
import MissionsAPI from "../../api/api_calls/MissionAPI";
import NotesAPI from "../../api/api_calls/NotesAPI";



function SelectAudienceFormat(props) {

    const [audienceType, setAudienceType] = useState("");
    const [formatType, setFormatType] = useState("");
    const [audienceChosen, setAudienceChosen] = useState(false);

    const createMissionSubtitle = !audienceChosen ? "What audience are you targeting?" : "What type of research would you like to do?"

    const navigate = useNavigate();
    const alert = useAlert();


    function onAudienceClick(string) {
        setAudienceType(string);
        setAudienceChosen(true);
    }

    function onFormatClick(formatString) {
        setFormatType(formatString);

        // Create the mission and move to the next page.

        async function createMission() {
            const result = await MissionsAPI.create(formatString, navigate);

            if (result.success) {
                const missionId = result.mission.id;
                if (formatString == "interview") {
                    navigate("/createmission/" + missionId + "/sessiondetails", { state: { missionId: missionId, audienceType: audienceType, formatType: formatString } });
                } else if (formatString == "survey") {
                    navigate("/createmission/" + missionId + "/surveydetails", { state: { missionId: missionId, audienceType: audienceType, formatType: formatString } });
                } else {
                    alert.show("Invalid mission format", { type: 'error' })
                }

            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        createMission();
    }

    function onBackClick() {
        setAudienceChosen(false);
    }

    function createNote(action) {
        async function createTheNote() {
            const result = await NotesAPI.create({ mission_id: null, action: action, handleRedirect: navigate });
        }
        createTheNote()
    }


    //Audience Modal State
    const [audienceModalIsOpen, setAudienceModalIsOpen] = useState(false);
    const [toggledAudienceNote, setToggledAudienceNote] = useState(false);
    const toggleAudienceModal = () => {
        setAudienceModalIsOpen(!audienceModalIsOpen);

        if (!toggledAudienceNote) {
            createNote("Clicked 'Your Community' link while creating a mission.")
            setToggledAudienceNote(true);
        }
    }

    //Format Modal State
    const [formatModalIsOpen, setFormatModalIsOpen] = useState(false);
    const [toggledFormatdNote, setToggledFormatNote] = useState(false);
    const toggleFormatModal = () => {
        setFormatModalIsOpen(!formatModalIsOpen);

        if (!toggledFormatdNote) {
            createNote("Clicked 'Need a different format?' link while creating a mission.")
            setToggledFormatNote(true);
        }
    }

    function AudienceSelectionSection() {
        return (
            <>
                <div className="square-button-container">
                    <UserPoolButton onClick={() => onAudienceClick("User Pool")} />
                    <YourCommunityButton onClick={() => toggleAudienceModal()} />
                </div>
                <PurpleYourCommunityModal isOpen={audienceModalIsOpen} toggleModal={toggleAudienceModal} />
            </>
        )
    }

    function FormatSelectionSection() {
        return (
            <>
                <div className="square-button-and-text-link-container">
                    <div className="square-button-container">
                        <LiveFeedbackButton onClick={() => onFormatClick("interview")} />
                        <SurveyButton onClick={() => onFormatClick("survey")} />
                    </div>
                    <TertiaryLink text="Need a different format?" onClick={toggleFormatModal} />
                    <PurpleOtherFormatsModal isOpen={formatModalIsOpen} toggleModal={toggleFormatModal} />
                    <BackButton onClick={() => onBackClick()} />
                </div>
            </>
        )
    }


    return (
        <MainSection excludeGridBg={true} >
            <CreateMissionTitleSection subtext={createMissionSubtitle} />
            {!audienceChosen ? <AudienceSelectionSection /> : <FormatSelectionSection />}
        </MainSection>
    )

}

function CreateMissionTitleSection(props) {
    return (
        <div className="create-mission-title-div">
            <div className="create-mission-title">
                Create Project
            </div>
            <div className="create-mission-subtitle">
                {props.subtext}
            </div>
        </div>
    )
}

export default SelectAudienceFormat;